import React from 'react';
import { getVisiblePageRange } from '../functions';
import { FrameworkPaginationProps } from '../interfaces';

export const FrameworkPagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}: FrameworkPaginationProps) => {
  if (totalPages <= 1) return null;

  const { startPage, endPage } = getVisiblePageRange(currentPage, totalPages);
  const pages = [];

  if (startPage > 1) {
    pages.push(
      <button
          key='first'
          onClick={() => onPageChange(1)}
          className='px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors'
      >
        1
      </button>,
    );
    if (startPage > 2) {
      pages.push(
        <span key='ellipsis-start' className='px-2 text-gray-400'>
          ...
        </span>,
      );
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`px-3 py-1 text-sm border rounded transition-colors ${
            currentPage === i
              ? 'bg-green-600 text-white border-green-600 font-medium'
              : 'border-gray-300 hover:bg-gray-50 text-gray-700'
          }`}
      >
        {i}
      </button>,
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(
        <span key='ellipsis-end' className='px-2 text-gray-400'>
          ...
        </span>,
      );
    }
    pages.push(
      <button
          key='last'
          onClick={() => onPageChange(totalPages)}
          className='px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors'
      >
        {totalPages}
      </button>,
    );
  }

  const startCount = (currentPage - 1) * itemsPerPage + 1;
  const endCount = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className='p-3 border-t border-gray-200 flex items-center justify-between'>
      <div className='text-xs text-gray-600'>
        Showing {startCount}-{endCount} of {totalItems.toLocaleString()}
      </div>
      <div className='flex items-center gap-1'>
        <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className='px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
        >
          Previous
        </button>
        {pages}
        <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className='px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
        >
          Next
        </button>
      </div>
    </div>
  );
};
